// SimTech Store – Theme JS v3

document.addEventListener('DOMContentLoaded', function () {

  // ── MOBILE MENU ──────────────────────────────────────
  var toggle = document.getElementById('st-menu-toggle');
  var mobileNav = document.getElementById('st-mobile-nav');
  if (toggle && mobileNav) {
    toggle.addEventListener('click', function () {
      mobileNav.classList.toggle('open');
    });
    // Close mobile nav when viewport grows past burger breakpoint
    window.addEventListener('resize', function () {
      if (window.innerWidth > 1200 && mobileNav.classList.contains('open')) {
        mobileNav.classList.remove('open');
      }
    });
  }

  // ── CART COUNT + DRAWER INIT ─────────────────────────
  fetchCart();
  initCartDrawer();

  // ── STICKY PRODUCT BAR ───────────────────────────────
  var sticky = document.getElementById('st-sticky');
  if (sticky) {
    window.addEventListener('scroll', function () {
      sticky.classList.toggle('show', window.scrollY > 500);
    });
  }

  // ── PRODUCT THUMBNAILS ───────────────────────────────
  var mainImg = document.getElementById('st-main-img');
  document.querySelectorAll('.st-thumb').forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      document.querySelectorAll('.st-thumb').forEach(function (t) { t.classList.remove('active'); });
      thumb.classList.add('active');
      if (mainImg && thumb.dataset.src) {
        mainImg.src = thumb.dataset.src;
      }
    });
  });

  // ── IMAGE ZOOM ───────────────────────────────────────
  if (mainImg) {
    mainImg.style.cursor = 'zoom-in';
    mainImg.addEventListener('click', function () {
      var zoomOverlay = document.getElementById('st-zoom-overlay');
      var zoomImg = document.getElementById('st-zoom-img');
      if (!zoomOverlay || !zoomImg) return;
      zoomImg.src = mainImg.src.replace(/width=\d+/, 'width=2000');
      zoomOverlay.classList.add('open');
      document.body.style.overflow = 'hidden';
    });
  }
  var zoomOverlay = document.getElementById('st-zoom-overlay');
  var zoomClose = document.getElementById('st-zoom-close');
  function closeZoom() {
    if (zoomOverlay) zoomOverlay.classList.remove('open');
    document.body.style.overflow = '';
  }
  if (zoomClose) zoomClose.addEventListener('click', closeZoom);
  if (zoomOverlay) zoomOverlay.addEventListener('click', function (e) {
    if (e.target === zoomOverlay) closeZoom();
  });

  // ── QTY CONTROLS ─────────────────────────────────────
  var qtyEl = document.getElementById('st-qty');
  var qtyMinus = document.getElementById('st-qty-minus');
  var qtyPlus = document.getElementById('st-qty-plus');
  if (qtyEl) {
    if (qtyMinus) qtyMinus.addEventListener('click', function () {
      var v = parseInt(qtyEl.textContent);
      if (v > 1) qtyEl.textContent = v - 1;
    });
    if (qtyPlus) qtyPlus.addEventListener('click', function () {
      qtyEl.textContent = parseInt(qtyEl.textContent) + 1;
    });
  }

  // ── ADD TO CART (Produktseite) ────────────────────────
  var addBtn = document.getElementById('st-add-to-cart');
  if (addBtn) {
    addBtn.addEventListener('click', function () {
      var variantId = addBtn.dataset.variantId;
      var qty = qtyEl ? parseInt(qtyEl.textContent) : 1;
      if (!variantId) return;
      addToCart(variantId, qty, addBtn);
    });
    var stickyBtn = document.getElementById('st-sticky-btn');
    if (stickyBtn) stickyBtn.addEventListener('click', function () { addBtn.click(); });
  }

  // ── VARIANT BUTTONS ───────────────────────────────────
  var variantBtns = document.querySelectorAll('.st-var-btn');
  variantBtns.forEach(function (btn) {
    btn.addEventListener('click', function () {
      if (btn.disabled) return;
      variantBtns.forEach(function (b) { b.classList.remove('active'); });
      btn.classList.add('active');

      var price       = btn.dataset.price;
      var comparePrice = btn.dataset.comparePrice;
      var variantId   = btn.dataset.variantId;
      var available   = btn.dataset.available === 'true';

      var priceEl      = document.getElementById('st-price-main');
      var oldPriceEl   = document.getElementById('st-price-old');
      var stickyPriceEl = document.getElementById('st-sticky-price');

      if (priceEl && price)      priceEl.textContent = formatMoney(parseInt(price));
      if (oldPriceEl) {
        if (comparePrice && parseInt(comparePrice) > parseInt(price)) {
          oldPriceEl.textContent = formatMoney(parseInt(comparePrice));
          oldPriceEl.style.display = '';
        } else {
          oldPriceEl.style.display = 'none';
        }
      }
      if (stickyPriceEl && price) stickyPriceEl.textContent = formatMoney(parseInt(price));
      if (addBtn) {
        addBtn.dataset.variantId = variantId;
        addBtn.disabled          = !available;
        addBtn.textContent       = available ? 'In den Warenkorb legen' : 'Ausverkauft';
        addBtn.style.opacity     = available ? '1' : '0.5';
        addBtn.style.cursor      = available ? 'pointer' : 'not-allowed';
      }

      // Sync dynamic checkout hidden input
      var dcoVariant = document.getElementById('st-dco-variant');
      if (dcoVariant && variantId) dcoVariant.value = variantId;

      // Urgency update
      var urgStock = document.querySelector('.st-urg-stock');
      if (urgStock) {
        var dot  = urgStock.querySelector('.st-urg-dot');
        var span = urgStock.querySelector('span:last-child');
        if (dot)  { dot.style.background = available ? '' : '#888'; dot.style.animation = available ? '' : 'none'; }
        if (span) span.textContent = available ? 'Auf Lager' : 'Ausverkauft';
      }
    });
  });

  // ── QUICK-ADD ─────────────────────────────────────────
  document.querySelectorAll('.st-quick-add').forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      var variantId = btn.dataset.variantId;
      if (!variantId) return;
      var orig = btn.textContent;
      btn.textContent = '…';
      btn.disabled = true;
      addToCart(variantId, 1, null, function () {
        btn.textContent = '✓';
        setTimeout(function () { btn.textContent = orig; btn.disabled = false; }, 2000);
      });
    });
  });

  // ── COLLECTION SORT ───────────────────────────────────
  var sortSelect = document.getElementById('st-sort');
  if (sortSelect) {
    var params = new URL(window.location.href).searchParams;
    var cur = params.get('sort_by');
    if (cur) sortSelect.value = cur;
    sortSelect.addEventListener('change', function () {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', sortSelect.value);
      window.location.href = url.toString();
    });
  }

  // ── BACK TO TOP ───────────────────────────────────────
  var btt = document.getElementById('st-back-top');
  if (btt) {
    window.addEventListener('scroll', function () {
      btt.classList.toggle('show', window.scrollY > 700);
    });
    btt.addEventListener('click', function () {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    });
  }

  // ── EXPRESS SHIPPING – ZEITPRÜFUNG ───────────────────
  // Versteckt "Wird heute versendet"-Elemente nach 14:00 Uhr
  // (Europe/Berlin) sowie an Samstag und Sonntag.
  checkExpressShippingTime();

  // ── KEYBOARD ESC ─────────────────────────────────────
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      closeZoom();
      closeCartDrawer();
    }
  });

});

// ══════════════════════════════════════════════════════
// CART DRAWER
// ══════════════════════════════════════════════════════
function initCartDrawer() {
  var overlay  = document.getElementById('st-drawer-overlay');
  var closeBtn = document.getElementById('st-drawer-close');

  // Redirect cart icon to drawer
  document.querySelectorAll('a[href="/cart"]').forEach(function (link) {
    link.addEventListener('click', function (e) {
      // Only intercept in header (not cart page links inside drawer)
      if (link.closest('.st-cart-drawer') || link.closest('.st-drawer-footer')) return;
      e.preventDefault();
      openCartDrawer();
    });
  });

  if (overlay)  overlay.addEventListener('click', closeCartDrawer);
  if (closeBtn) closeBtn.addEventListener('click', closeCartDrawer);
}

function openCartDrawer() {
  document.getElementById('st-cart-drawer').classList.add('open');
  document.getElementById('st-drawer-overlay').classList.add('open');
  document.body.style.overflow = 'hidden';
  fetchCart();
}

function closeCartDrawer() {
  var drawer  = document.getElementById('st-cart-drawer');
  var overlay = document.getElementById('st-drawer-overlay');
  if (drawer)  drawer.classList.remove('open');
  if (overlay) overlay.classList.remove('open');
  document.body.style.overflow = '';
}

function renderCartDrawer(cart) {
  var body   = document.getElementById('st-drawer-body');
  var footer = document.getElementById('st-drawer-footer');
  if (!body) return;

  if (cart.item_count === 0) {
    body.innerHTML = [
      '<div class="st-drawer-empty">',
      '<svg width="52" height="52" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.2" opacity=".25"><path d="M6 2L3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z"/><line x1="3" y1="6" x2="21" y2="6"/><path d="M16 10a4 4 0 0 1-8 0"/></svg>',
      '<p>Dein Warenkorb ist leer</p>',
      '<a href="/collections/all" class="st-btn-primary" style="font-size:13px;padding:14px 28px;">Weiter shoppen</a>',
      '</div>'
    ].join('');
    if (footer) footer.style.display = 'none';
    return;
  }

  var html = '';
  cart.items.forEach(function (item, i) {
    html += '<div class="st-di">';
    html += '<a href="' + item.url + '" class="st-di__img">' + (item.image ? '<img src="' + item.image + '" alt="' + item.product_title + '" loading="lazy" width="80" height="80">' : '') + '</a>';
    html += '<div class="st-di__info">';
    html += '<div class="st-di__name">' + item.product_title + '</div>';
    if (item.variant_title && item.variant_title !== 'Default Title') {
      html += '<div class="st-di__var">' + item.variant_title + '</div>';
    }
    html += '<div class="st-di__price">' + formatMoney(item.final_price) + '</div>';
    html += '</div>';
    html += '<div class="st-di__right">';
    html += '<div class="st-di__qty">';
    html += '<button onclick="updateCartItem(' + (i + 1) + ',' + (item.quantity - 1) + ')" class="st-dq-btn" aria-label="Weniger">−</button>';
    html += '<span>' + item.quantity + '</span>';
    html += '<button onclick="updateCartItem(' + (i + 1) + ',' + (item.quantity + 1) + ')" class="st-dq-btn" aria-label="Mehr">+</button>';
    html += '</div>';
    html += '<button onclick="updateCartItem(' + (i + 1) + ',0)" class="st-di__rm" aria-label="Entfernen">';
    html += '<svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>';
    html += '</button>';
    html += '</div>';
    html += '</div>';
  });
  body.innerHTML = html;

  if (footer) {
    footer.style.display = '';
    var totalEl    = document.getElementById('st-drawer-total');
    var shippingEl = document.getElementById('st-drawer-shipping');
    if (totalEl) totalEl.textContent = formatMoney(cart.total_price);
    if (shippingEl) {
      if (cart.total_price >= 30000) {
        shippingEl.innerHTML = '<span class="st-ship-free">✓ Kostenloser Versand inklusive</span>';
      } else {
        var remaining = 30000 - cart.total_price;
        shippingEl.innerHTML = 'Noch <strong>' + formatMoney(remaining) + '</strong> bis zum <strong>kostenlosen Versand</strong>';
      }
    }
  }
}

function updateCartItem(line, qty) {
  fetch('/cart/change.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ line: line, quantity: qty })
  })
  .then(function (r) { return r.json(); })
  .then(function () { fetchCart(); })
  .catch(function () {});
}

// ══════════════════════════════════════════════════════
// SHARED HELPERS
// ══════════════════════════════════════════════════════
function addToCart(variantId, qty, btn, callback) {
  if (btn) { btn.textContent = 'Wird hinzugefügt…'; btn.disabled = true; }
  fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: parseInt(variantId), quantity: qty || 1 })
  })
  .then(function (r) { return r.json(); })
  .then(function () {
    fetchCart();
    openCartDrawer();
    if (btn) {
      btn.textContent     = '✓ Im Warenkorb';
      btn.style.background = '#1a1a1a';
      setTimeout(function () {
        btn.textContent     = 'In den Warenkorb legen';
        btn.style.background = '';
        btn.disabled        = false;
      }, 2500);
    }
    if (callback) callback();
  })
  .catch(function () {
    if (btn) { btn.textContent = 'In den Warenkorb legen'; btn.disabled = false; }
  });
}

function fetchCart() {
  fetch('/cart.js')
    .then(function (r) { return r.json(); })
    .then(function (cart) {
      var countEl = document.getElementById('st-cart-count');
      if (countEl) {
        countEl.textContent = cart.item_count > 0 ? cart.item_count : '';
        countEl.style.display = cart.item_count > 0 ? 'flex' : 'none';
      }
      renderCartDrawer(cart);
    })
    .catch(function () {});
}

function formatMoney(cents) {
  return (cents / 100).toFixed(2).replace('.', ',') + ' €';
}

// ══════════════════════════════════════════════════════
// EXPRESS SHIPPING ZEITPRÜFUNG
// ══════════════════════════════════════════════════════
function checkExpressShippingTime() {
  // Holt aktuelle Uhrzeit in der Zeitzone Europe/Berlin
  var berlinString = new Date().toLocaleString('en-US', { timeZone: 'Europe/Berlin' });
  var berlinDate   = new Date(berlinString);
  var day  = berlinDate.getDay();  // 0 = Sonntag, 6 = Samstag
  var hour = berlinDate.getHours();

  // Bedingungen: Wochenende ODER nach 14 Uhr -> Express ausblenden
  var hideExpress = (day === 0 || day === 6) || (hour >= 14);

  if (!hideExpress) return; // Express darf angezeigt werden -> nichts tun

  // Alle Elemente mit data-express="true" ausblenden
  document.querySelectorAll('[data-express="true"]').forEach(function (el) {
    el.style.display = 'none';
  });
}
